export const SUBSCRIBE_REQUEST = 'NOTIFICATIONS/SUBSCRIBE/REQUEST';
export const SUBSCRIBE_SUCCESS = 'NOTIFICATIONS/SUBSCRIBE/SUCCESS';
export const SUBSCRIBE_FAILURE = 'NOTIFICATIONS/SUBSCRIBE/FAILURE';

export const UNSUBSCRIBE_REQUEST = 'NOTIFICATIONS/UNSUBSCRIBE/REQUEST';
export const UNSUBSCRIBE_SUCCESS = 'NOTIFICATIONS/UNSUBSCRIBE/SUCCESS';
export const UNSUBSCRIBE_FAILURE = 'NOTIFICATIONS/UNSUBSCRIBE/FAILURE';

export const ADD = 'NOTIFICATIONS/ADD';

export const DELETE_NOTIFICATION = 'NOTIFICATIONS/DELETE/REQUEST';
export const DELETE_NOTIFICATION_SUCCESS = 'NOTIFICATIONS/DELETE/SUCCESS';
export const DELETE_NOTIFICATION_FAILURE = 'NOTIFICATIONS/DELETE/FAILURE';

export const FETCH_NOTIFICATIONS = 'NOTIFICATIONS/FETCH/REQUEST';
export const FETCH_NOTIFICATIONS_SUCCESS = 'NOTIFICATIONS/FETCH/SUCCESS';
export const FETCH_NOTIFICATIONS_FAILURE = 'NOTIFICATIONS/FETCH/FAILURE';

export const FETCH_NOTIFICATIONS_DASHBOARD = 'NOTIFICATIONS/DASHBOARD/FETCH/REQUEST';
export const FETCH_NOTIFICATIONS_DASHBOARD_SUCCESS = 'NOTIFICATIONS/DASHBOARD/FETCH/SUCCESS';
export const FETCH_NOTIFICATIONS_DASHBOARD_FAILURE = 'NOTIFICATIONS/DASHBOARD/FETCH/FAILURE';
export const RESET_NOTIFICATIONS_DASHBOARD = 'NOTIFICATIONS/DASHBOARD/RESET';

export const FETCH_DROPDOWN_NOTIFICATIONS = 'NOTIFICATIONS/DROPDOWN/FETCH/REQUEST';
export const FETCH_DROPDOWN_NOTIFICATIONS_SUCCESS = 'NOTIFICATIONS/DROPDOWN/FETCH/SUCCESS';
export const FETCH_DROPDOWN_NOTIFICATIONS_FAILURE = 'NOTIFICATIONS/DROPDOWN/FETCH/FAILURE';

export const FETCH_UNREAD_NOTIFICATIONS_COUNT = 'NOTIFICATIONS/UNREAD/FETCH/REQUEST';
export const FETCH_UNREAD_NOTIFICATIONS_COUNT_SUCCESS = 'NOTIFICATIONS/UNREAD/FETCH/SUCCESS';
export const FETCH_UNREAD_NOTIFICATIONS_COUNT_FAILURE = 'NOTIFICATIONS/UNREAD/FETCH/FAILURE';

export const MARK_AS_UNREAD = 'NOTIFICATIONS/MARK_AS_UNREAD/POST';
export const MARK_AS_UNREAD_SUCCESS = 'NOTIFICATIONS/MARK_AS_UNREAD/SUCCESS';
export const MARK_AS_UNREAD_FAILURE = 'NOTIFICATIONS/MARK_AS_UNREAD/FAILURE ';

export const MARK_AS_READ = 'NOTIFICATIONS/MARK_AS_READ/POST';
export const MARK_AS_READ_SUCCESS = 'NOTIFICATIONS/MARK_AS_READ/SUCCESS';
export const MARK_AS_READ_FAILURE = 'NOTIFICATIONS/MARK_AS_READ/FAILURE ';

export const MARK_ALL_AS_READ = 'NOTIFICATIONS/MARK_ALL_AS_READ/POST';
export const MARK_ALL_AS_READ_SUCCESS = 'NOTIFICATIONS/MARK_ALL_AS_READ/SUCCESS';
export const MARK_ALL_AS_READ_FAILURE = 'NOTIFICATIONS/MARK_ALL_AS_READ/FAILURE';

export const FETCH_CONFIGURATION = 'NOTIFICATIONS/CONFIGURATION/FETCH/REQUEST';
export const FETCH_CONFIGURATION_SUCCESS = 'NOTIFICATIONS/CONFIGURATION/FETCH/SUCCESS';
export const FETCH_CONFIGURATION_FAILURE = 'NOTIFICATIONS/CONFIGURATION/FETCH/FAILURE';

export const PATCH_CONFIGURATION = 'NOTIFICATIONS/CONFIGURATION/PATCH/REQUEST';
export const PATCH_CONFIGURATION_SUCCESS = 'NOTIFICATIONS/CONFIGURATION/PATCH/SUCCESS';
export const PATCH_CONFIGURATION_FAILURE = 'NOTIFICATIONS/CONFIGURATION/PATCH/FAILURE';
export const DISABLED_NOTIFICATION_SETTING = 'NOTIFICATIONS/CONFIGURATION/DISABLED/NOTIFICATION_SETTING';

export const SET_SETTINGS_EXTENSION = 'NOTIFICATIONS/CONFIGURATION/UI/SET/FEATURE';

export const OPEN_PERMISSION_MODAL = 'NOTIFICATIONS/PERMISSIONS/OPEN';
export const REFUSE_PERMISSION = 'NOTIFICATIONS/PERMISSIONS/REFUSE';
export const ACCEPT_PERMISSION = 'NOTIFICATIONS/PERMISSIONS/ACCEPT';
export const NOTIFICATIONS_BLOCKED = 'NOTIFICATIONS/BLOCKED';
